import { Box, MenuItem } from '@mui/material';
import { formatDistanceToNowStrict } from 'date-fns';

import Typography from '@/components/Typography';
import { useChat } from '@/features/AIChat/context/useChat';
import { Conversation } from '@/features/AIChat/types/chat';

const HistoryRecord = ({
  conversation,
  handleClose,
  index
}: {
  conversation: Conversation;
  handleClose: () => void;
  index: number;
}) => {
  const { setMessages, setConversationId } = useChat();

  return (
    <MenuItem
      sx={{
        height: '40px'
      }}
      onClick={() => {
        setMessages(conversation.messages);
        setConversationId(conversation.conversationId);
        handleClose();
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        <Typography
          sx={{
            lineHeight: 1,
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={conversation.name}
        >
          {conversation.name || `My chat #${index + 1}`}
        </Typography>
        <Typography
          sx={{
            fontSize: '10px',
            color: 'var(--GX-Text-Disabled, #6C737A)',
            lineHeight: 1,
            flex: 'none'
          }}
        >
          {formatDistanceToNowStrict(new Date(conversation.timestamp))} ago
        </Typography>
      </Box>
    </MenuItem>
  );
};

export default HistoryRecord;
